/**
 * What kind of business a carrier writes, used to pre-filter the carrier
 * picker on a contract request.
 *
 * The per-carrier attributes are not populated yet. Until they are, a carrier
 * with no entry matches every filter — an unclassified carrier is never hidden
 * from an agent who is trying to contract with it.
 */
import { CARRIER_SLUG_TO_CARRIER } from "./carriers.js";
export const CARRIER_PRODUCT_TYPES = ["LIFE", "ANNUITY"];
export const CARRIER_PRODUCT_TYPE_LABELS = {
    LIFE: "Life",
    ANNUITY: "Annuity",
};
/** The picker's filter options, "All" first. */
export const CARRIER_PRODUCT_FILTER_OPTIONS = [
    { value: "all", label: "All" },
    ...CARRIER_PRODUCT_TYPES.map((type) => ({
        value: type,
        label: CARRIER_PRODUCT_TYPE_LABELS[type],
    })),
];
/**
 * Carrier → the product types it writes.
 *
 * TODO: fill this in from the carrier attribute list. Every carrier left out
 * shows under all three filters, so an incomplete map degrades to today's
 * unfiltered behaviour rather than hiding carriers.
 */
export const CARRIER_PRODUCTS = {};
export function isCarrierProductType(value) {
    return (typeof value === "string" && CARRIER_PRODUCT_TYPES.includes(value));
}
/**
 * Whether a carrier should appear under a product filter. Accepts the Carrier
 * enum value or the lowercase contract slug. An unclassified carrier matches
 * everything, so nothing disappears before the attributes land.
 */
export function carrierMatchesProductType(carrier, productType) {
    if (!productType || productType === "all")
        return true;
    if (!isCarrierProductType(productType))
        return true;
    if (!carrier)
        return true;
    const resolved = CARRIER_SLUG_TO_CARRIER[carrier.trim().toLowerCase()];
    const products = resolved ? CARRIER_PRODUCTS[resolved] : undefined;
    if (!products || products.length === 0)
        return true;
    return products.includes(productType);
}
